<template>
    <div>
        <navigation class="age-gate__nav" />
        <main>
            <div class="age-gate">
                <div class="container">
                    <div class="image">
                        <img class="" src="../../assets/mixology/mix_n_mingle-loop.gif" alt="mix and mingle" />
                    </div>
                    <div class="form">
                        <h1>{{ mixologyData.AGE_GATE.TITLE }}</h1>
                        <p v-html="mixologyData.AGE_GATE.COPY"></p>
                        <div class="copy">
                            <div class="field">
                                <div class="control">
                                    <form id="user">
                                        <input type="text" name="month" id="month" v-model="month" placeholder="mm">
                                        <input type="text" name="day" id="day" v-model="day" placeholder="dd">
                                        <input type="text" name="year" id="year" v-model="year" placeholder="yyyy">
                                        <input  class="input" type="button" value="ok" v-on:click="checkForm" :disabled='!isComplete'>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        </main>
        <mix-footer />
    </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import mixologyData from "./../../../static/libs/mixology";
import MixFooter from '@/components/mixology/MixFooter';
import * as moment from "moment";

export default {
    name: "agegate",
    data(){
        return {
            day:"",
            month:"",
            year:"",
            mixologyData
        }
    },
    methods:{
        checkForm:function(e) {
            let birthday = moment(moment.now()).diff(moment(this.day + this.month + this.year, "DD.MM.YYYY"),"years");

            if(birthday > 21) {
                //alert("greater than 21")
                window.sessionStorage.setItem('ofAge', true);
                // e.preventDefault();
            } else {
                //alert("less than 21")
                window.sessionStorage.setItem('ofAge', false);
                // e.preventDefault();
            }

            // this.$router.push().catch(err => {})
            window.location.reload()

        }
    },
    computed: {
        isComplete () {
            return this.day && this.month && this.year;
        }
    },
    components:{
        Navigation,
        MixFooter
    }
}
</script>

<style lang="scss" scoped>
  @import './../../variables';

.age-gate {
    background-color: $bubly-blue-light;
    background-image: url('./../../assets/mix/cans.png'), url('./../../assets/mixology/bubbles.png');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: contain;
    height: calc(100vh - 88px);
    min-height: 667px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__nav {
        justify-self: start;
        background-color: #fff
    }

    h1 {
        font-size: 4rem;
    }

    p {
        font-size: 1.25rem;
        line-height: 1.25rem;
        margin-top: -40px;
    }

    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-top: -200px;
        padding: 14px;
        box-sizing: border-box;
        

        .image {
            width: 45%;
            max-width: 170px;
        }

        .form {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 400px;
        }

        #user {
            display: flex;
            flex-wrap: wrap;
            // flex-basis: 1 1 auto;
            justify-content: center;
        }

        input, submit {
            font-size: 1.75em;
            border: 4px solid #fff;
            box-sizing: border-box;
            width: 13.33%;
        }

        input {
            width: 33.33%;
            font-family: inherit;
            background: rgba(0,0,0,0.18);
            color: #fff;
            font-size: 0.938em;
            font-weight: 700;
            margin: 0;
            padding: 0.5em 0.25em;
            text-align: center;

            &::placeholder {
                color: #fff;
            }
        }
        input:nth-child(1) {
            border-radius: 10px 0 0 10px;
            border: 4px solid #fff;
        }
        input:nth-child(2) {
            border: 0;
            border-top: 4px solid #fff;
            border-bottom: 4px solid #fff;
        }
        input:nth-child(3) {
            border: 4px solid #fff;
            border-radius: 0 10px 10px 0;
        }

        input[type="button"] {
            width: 100%;
            cursor: pointer;
            background-color: $bubly-blue;
            border-radius: 10px;

            margin-top: 15px;

            &:disabled {
                background: grey;
            }
        }

        @media(min-width: 576px) {
            flex-direction: row;

            .image {
                min-width: 192px;
                max-width: 280px;
            }

            .form {
                margin: 0 50px;
            }
        }

        @media(min-width: 768px) {

            
            input {
                width: 25%;
            }
            
            input[type="button"] {
                width: 19%;
                margin: 0 8px;
            }
        }

        @media(min-width: 1024px) {
            input {
                font-size: 1.75em;
            }
            
        }

    }
}






</style>



// WEBPACK FOOTER //
// src/components/mixology/AgeGate.vue